import { InventoryAdjustmentOpeningBalanceImportPage } from "@/features/inventory-adjustment/pages/InventoryAdjustmentOpeningBalanceImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/inventory-adjustment/opening-balance/import",
)({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["inventory_adjustment.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventoryAdjustmentOpeningBalanceImportPage,
});
